var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAiTechnologySparkStreamlineCore(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_78_41)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0084 11.386C11.4569 12.0134 10.7855 12.5293 10.0302 12.9015V15.0444C10.0302 15.2338 9.95494 15.4155 9.82098 15.5494C9.68703 15.6834 9.50534 15.7587 9.3159 15.7587H5.03018C4.84076 15.7587 4.65907 15.6834 4.52511 15.5494C4.39116 15.4155 4.3159 15.2338 4.3159 15.0444V12.9015C3.28797 12.3914 2.4153 11.6156 1.78847 10.6544C1.16165 9.6932 0.80353 8.58176 0.751294 7.43545C0.699058 6.28912 0.954608 5.14972 1.49141 4.1355C2.02823 3.1213 2.82671 2.26926 3.804 1.66786C4.78128 1.06645 5.90174 0.737596 7.04904 0.715433C8.0062 0.696942 8.95293 0.892476 9.82098 1.28483",
    stroke: "#215250",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.31592 19.2856H10.0302",
    stroke: "#215250",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5637 5.61988C10.0624 5.53266 10.0624 4.81298 10.5637 4.72576C12.38 4.40979 13.8245 3.02642 14.2187 1.22555L14.249 1.08751C14.3574 0.592032 15.0629 0.588948 15.1756 1.08346L15.2124 1.24433C15.6212 3.03669 17.0661 4.40839 18.8774 4.72348C19.3812 4.81115 19.3812 5.53449 18.8774 5.62215C17.0661 5.93725 15.6212 7.30895 15.2124 9.10131L15.1756 9.26218C15.0629 9.75669 14.3574 9.75361 14.249 9.25813L14.2187 9.12009C13.8245 7.31923 12.38 5.93585 10.5637 5.61988Z",
    stroke: "#EA7F4A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_78_41"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiTechnologySparkStreamlineCore);
export default __webpack_public_path__ + "static/media/Ai-Technology-Spark--Streamline-Core.58f560af06bb27bb9df1df308cf1d4a2.svg";
export { ForwardRef as ReactComponent };